<script setup lang="ts">
    import { __ } from '../stores/expressions';

    const props = withDefaults(
        defineProps<{
            class?: string;
            color?: boolean;
        }>(),
        {
            class: '',
            color: true,
        }
    );
</script>

<template>
    <div :class="props.class" class="flex space-x-2 justify-center items-center">
        <span class="sr-only">{{ __('loading') }}</span>
        <div
            :class="{
                'bg-gray-light': !props.color,
                'bg-primary-beet': props.color,
            }"
            class="rounded-full h-3 w-3 animate-bounce [animation-delay:-0.3s]"
        />
        <div
            :class="{
                'bg-gray-light': !props.color,
                'bg-primary-beet': props.color,
            }"
            class="rounded-full h-3 w-3 animate-bounce [animation-delay:-0.15s]"
        />
        <div
            :class="{
                'bg-gray-light': !props.color,
                'bg-primary-beet': props.color,
            }"
            class="rounded-full h-3 w-3 animate-bounce"
        />
    </div>
</template>
